import Lottie from 'lottie-react';

import json from '../jsons/medical-file-hover-pinch.json';

const MedicalFile = props => {
  return <Lottie loop={false} animationData={json} {...props} />;
};

export default MedicalFile;
